module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/icon-search-db149cf1a90e335920fa641f47cd89e7.png";